import { render, staticRenderFns } from "./CustomWishesYN.vue?vue&type=template&id=cf2ac2a6"
import script from "./CustomWishesYN.vue?vue&type=script&lang=js"
export * from "./CustomWishesYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports